module.exports = __webpack_public_path__ + "img/Manuel-19.14ceb4fd.jpg";